import { render, staticRenderFns } from "./BeeMaterialAmountLabel.vue?vue&type=template&id=28b69c5d&"
import script from "./BeeMaterialAmountLabel.vue?vue&type=script&lang=js&"
export * from "./BeeMaterialAmountLabel.vue?vue&type=script&lang=js&"
import style0 from "./BeeMaterialAmountLabel.vue?vue&type=style&index=0&id=28b69c5d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports